import { parseVoiceoverVideoPlan, type VoiceoverVideoPlan } from './planner-schema'

export function validatePlannerResponse(rawContent: string): VoiceoverVideoPlan {
  return parseVoiceoverVideoPlan(rawContent)
}